import React from 'react';
import { MIcon } from '../../lib/micon';
import './KarussellHeader.css';

interface KarussellHeaderProps {
  onZurueck: () => void;
  onVorher: () => void;
  onNaechster: () => void;
  suchterm?: string;
  setSuchterm?: (v: string) => void;
  sucheZeigen?: boolean;
  vorherDeaktiviert?: boolean;
  naechsterDeaktiviert?: boolean;
  zurueckLabel?: string;
  /** Welle P1b: „11 von 27“ neben den Pfeilen */
  position?: string;
  suchPlatzhalter?: string;
}

export function KarussellHeader({
  onZurueck, onVorher, onNaechster,
  suchterm = '', setSuchterm,
  sucheZeigen = true,
  vorherDeaktiviert = false, naechsterDeaktiviert = false,
  zurueckLabel = 'Zurück zur Übersicht',
  position, suchPlatzhalter = 'Suchen …',
}: KarussellHeaderProps) {
  return (
    <div className="ld-karussell-header">
      <button onClick={onZurueck} className="ld-karussell-zurueck">
        <MIcon name="chevron_left" size={18} />
        <span>{zurueckLabel}</span>
      </button>
      {sucheZeigen && setSuchterm && (
        <div className="ld-karussell-suche">
          <MIcon name="search" size={15} style={{ flexShrink: 0, color: 'var(--ld-text-secondary)' }} />
          <input
            value={suchterm}
            onChange={e => setSuchterm(e.target.value)}
            placeholder={suchPlatzhalter}
            aria-label={suchPlatzhalter}
          />
        </div>
      )}
      <div className="ld-karussell-nav">
        {position && <span className="ld-karussell-position">{position}</span>}
        <button onClick={onVorher} disabled={vorherDeaktiviert} aria-label="Vorheriges" className="ld-karussell-pfeil">
          <MIcon name="chevron_left" size={18} />
        </button>
        <button onClick={onNaechster} disabled={naechsterDeaktiviert} aria-label="Nächstes" className="ld-karussell-pfeil">
          <MIcon name="chevron_right" size={18} />
        </button>
      </div>
    </div>
  );
}
